import messages from 'containers/LawyerFeeNote/messages';

export const PROCEDURE_STEPS = {
  PV: 'PV',
  JUDGEMENT_ADD: 'JUDGEMENT_ADD',
  EXPERT_REPORT: 'EXPERT_REPORT',
  JUDGEMENT_ON_MERITS: 'JUDGEMENT_ON_MERITS',
  JUDGEMENT_APPEAL: 'APPEAL_JUDGEMENT',
  ARRET_ON_MERITS: 'ARRET_ON_MERITS',
  ARRET_ADD: 'ARRET_ADD',
  EXPERTISE_CONSEIL: 'EXPERTISE_CONSEIL',
  EXPERTISE_CONSEIL_APPRECIATION: 'EXPERTISE_CONSEIL_APPRECIATION',
  NOTICE_DEFICIENCY: 'NOTICE_DEFICIENCY',
};

export const PROCEDURE_STEPS_MESSAGE = {
  PV: messages.pv,
  JUDGEMENT_ADD: messages.judgementADD,
  EXPERT_REPORT: messages.expertReport,
  JUDGEMENT_ON_MERITS: messages.judgementOnMerits,
  JUDGEMENT_APPEAL: messages.judgementAppeal,
  ARRET_ADD: messages.arretAdd,
  ARRET_ON_MERITS: messages.arretOnMerits,
  EXPERTISE_CONSEIL: messages.expertiseConsulting,
  NOTICE_DEFICIENCY: messages.noticeDeficiency,
  POSTPONEMENTS_EXPERTISE: messages.postponementsExpertise,
  EXPERTISE_CONSEIL_APPRECIATION: messages.appreciationExpertiseRapport,
};

export const STATUS_MESSAGES = {
  PENDING: messages.pending,
  REJECTED: messages.rejected,
  VALIDATED: messages.validated,
};

export const ACTION = {
  VALIDATE: 'VALIDATE',
  REJECT: 'REJECT',
  CLOSED: 'CLOSED',
  ADD_FIRM_REFERENCE: 'ADD_FIRM_REFERENCE',
};

export const STATUS_PENDING = 'PENDING';
export const STATUS_REJECTED = 'REJECTED';
export const STATUS_VALIDATED = 'VALIDATED';
export const STATUS_CONTESTED = 'CONTESTED';
export const STATUS_VALIDATED_WITHOUT_CONTESTATION =
  'VALIDATED_WITHOUT_CONTESTATION';
export const STATUS_APPEL = 'APPEL';

export const ALL_STATUS = [STATUS_PENDING, STATUS_VALIDATED, STATUS_REJECTED];

// Documents Types
export const DOC_TYPES = ['TAX', 'THUMBNAIL', 'TRAVELLING_EXPENSES'];
export const MANAGER_DOC_TYPES = ['EXCEPTIONAL'];
export const DOC_MESSAGES = {
  TAX: messages.tax,
  THUMBNAIL: messages.thumbnail,
  TRAVELLING_EXPENSES: messages.travellingExpenses,
  EXCEPTIONAL: messages.exceptional,
};

export const JUSTIF_DOC_ID = '000';

// Actions Types
export const REQUEST_FEE_NOTES: string = 'REQUEST_FEE_NOTES';
export const REQUEST_LAWYER_FEE_NOTES: string = 'REQUEST_LAWYER_FEE_NOTES';
export const REQUEST_MANAGER_FEE_NOTES: string = 'REQUEST_MANAGER_FEE_NOTES';
export const SET_ALL_FEE_NOTES: string = 'SET_ALL_FEE_NOTES';
export const REQUEST_OPENING_MANAGER_FEE_NOTES: string =
  'REQUEST_OPENING_MANAGER_FEE_NOTES';
export const REQUEST_ALL_FEE_NOTES: string = 'REQUEST_ALL_FEE_NOTES';
export const REQUEST_CREATE_FEE_NOTE: string = 'REQUEST_CREATE_FEE_NOTE';
export const REQUEST_LAWYER_FEE_NOTES_BY_CLAIM_NUMBER: string =
  'REQUEST_LAWYER_FEE_NOTES_BY_CLAIM_NUMBER';
export const REQUEST_LAWYER_FEE_NOTES_BY_POLICY_NUMBER: string =
  'REQUEST_LAWYER_FEE_NOTES_BY_POLICY_NUMBER';
export const REQUEST_MANAGER_FEE_NOTES_BY_POLICY_NUMBER: string =
  'REQUEST_MANAGER_FEE_NOTES_BY_POLICY_NUMBER';
export const REQUEST_FEE_NOTES_BY_CLAIM_NUMBER: string =
  'REQUEST_FEE_NOTES_BY_CLAIM_NUMBER';
export const REQUEST_LAWYER_FEE_NOTES_BY_REGISTRATION_NUMBER: string =
  'REQUEST_LAWYER_FEE_NOTES_BY_REGISTRATION_NUMBER';
export const SET_CREATE_FEE_NOTE: string = 'SET_CREATE_FEE_NOTE';
export const SET_FEE_NOTES: string = 'SET_FEE_NOTES';
export const SET_SEARCH: string = 'SET_SEARCH';
export const MAKE_DECISION_FEE_NOTE: string = 'MAKE_DECISION_FEE_NOTE';
export const REQUEST_UPDATE_FEE_NOTE_AMOUNT: string =
  'REQUEST_UPDATE_FEE_NOTE_AMOUNT';
export const REQUEST_CREATE_FEE_NOTE_COSTS: string =
  'REQUEST_CREATE_FEE_NOTE_COSTS';
export const REQUEST_FEE_NOTE_EXCEPTIONAL_COSTS: string =
  'REQUEST_FEE_NOTE_EXCEPTIONAL_COSTS';
export const REQUEST_ALL_LAWYER_FEE_NOTES = 'REQUEST_ALL_LAWYER_FEE_NOTES';
export const REQUEST_UPDATE_FEE_NOTE: string = 'REQUEST_UPDATE_FEE_NOTE';
export const REQUEST_MANAGER_ALL_FEE_NOTES: string =
  'REQUEST_MANAGER_ALL_FEE_NOTES';
export const REQUEST_ADD_INVOICE_FEE_NOTE: string =
  'REQUEST_ADD_INVOICE_FEE_NOTE';
export const REQUEST_UPDATE_INVOICE_FEE_NOTE: string =
  'REQUEST_UPDATE_INVOICE_FEE_NOTE';
export const REQUEST_CREATE_FEE_NOTE_MANAGER =
  'REQUEST_CREATE_FEE_NOTE_MANAGER';
export const REQUEST_ADD_FEE_NOTE_EXCEPTIONAL_COSTS_SAGIS =
  'REQUEST_ADD_FEE_NOTE_EXCEPTIONAL_COSTS_SAGIS';

export const REQUEST_MANAGER_FEE_NOTES_BY_REGISTRATION_NUMBER =
  'REQUEST_MANAGER_FEE_NOTES_BY_REGISTRATION_NUMBER';

export const REQUEST_REJECT_FEE_NOTE_LAWYER = 'REQUEST_REJECT_FEE_NOTE_LAWYER';
export const REQUEST_GET_KPI_OVERDUE_INVOICE =
  'REQUEST_GET_KPI_OVERDUE_INVOICE';
export const REQUEST_SET_KPI_OVERDUE_INVOICE =
  'REQUEST_SET_KPI_OVERDUE_INVOICE';

export const PROCEDURE_STEPS_VALUES: any = {
  PV: 'Proces verbal',
  JUDGEMENT_ADD: 'Jugement ADD',
  EXPERT_REPORT: 'Rapport d’expertise',
  JUDGEMENT_ON_MERITS: 'Jugement au fond',
  JUDGEMENT_APPEAL: 'Appel',
  ARRET_ADD: 'Arrêt Add',
  ARRET_ON_MERITS: 'Arrêt au fond',
  EXPERTISE_CONSEIL: 'Expertise Conseil',
};

export const DEFAULT_LINK_BENEFICIARY_CODE = '149';
export const DEFAULT_LINK_AUXILIARE = '118';
export const DEFAULT_LINK_PROVIDER = '145';
export const PAYMENT_NATURE_COSTS = 'Frais Divers';
export const DOCTOR_ITEM_TYPE = 7;

export const CORRECTIONAL_JUDICIARY_PROCESS_ID = 3;

export const LIMIT_DATE_INVOICE = '01-07-2024';

export const REQUEST_UPDATE_FIRM_REFERENCE_MANAGER =
  'REQUEST_UPDATE_FIRM_REFERENCE_MANAGER';
export const FIRM_REFERENCE = 'firm_reference';
